import {
  Button,
  FormLabel,
  FormControl,
  OutlinedInput,
  Stack,
} from '@mui/material';
import { Provider } from '@repo/api-gw-sdk';

import { AllRegionsSelector } from '@/components/selectors/allRegionsSelector';
import type { StepProps } from '@/components/wizard/StepProps';
import { validateName } from '@/components/wizard/renameEntityName';

import type { StorageGatewayWizardState } from './storageGatewayWizardFlow';

export const GatewayNameSelection = (
  props: StepProps<StorageGatewayWizardState>
) => {
  const next = () => {
    props.setNextStep(props.currentStep.next?.[0]);
  };

  return (
    <Stack sx={{ height: '100%' }} alignItems='center' justifyContent='center'>
      <Stack width='400px' gap='40px'>
        <PolicyNameInput {...props} />
        <AllRegionsSelector
          size='medium'
          provider={Provider.Aws}
          regionName={props.wizardState.regionName}
          setRegionName={(regionName) =>
            props.setWizardState((state) => ({
              ...state,
              regionName,
            }))
          }
          title='Source region'
        />
        <Button
          data-testid='create-gateway-policy-name-continue-btn'
          variant='contained'
          disabled={!validateName(props.wizardState.dlsgPolicy.name)}
          onClick={next}
          sx={{ height: '48px' }}
        >
          Continue
          <i className='material-symbols-arrow-right-alt ml-[8px]' />
        </Button>
      </Stack>
    </Stack>
  );
};

const PolicyNameInput = (props: StepProps<StorageGatewayWizardState>) => {
  return (
    <Stack gap='16px'>
      <FormControl size='small' className='flex-1'>
        <FormLabel>Name</FormLabel>
        <OutlinedInput
          inputProps={{ 'data-testid': 'create-gateway-policy-name-input' }}
          autoFocus
          sx={{
            padding: '8px',
          }}
          placeholder='Use a descriptive name, so you could identify it later'
          onChange={(e) =>
            props.setWizardState((state) => ({
              ...state,
              dlsgPolicy: { ...state.dlsgPolicy, name: e.target.value },
            }))
          }
          value={props.wizardState.dlsgPolicy.name}
        />
      </FormControl>
    </Stack>
  );
};
